// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-message {
  line-height: 24px;
}
.alert-message svg {
  vertical-align: top;
  margin: 0 8px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/WarningMessage/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,mBAAA;EACA,iBAAA;AACJ","sourcesContent":[".alert-message {\n  line-height: 24px;\n\n  svg {\n    vertical-align: top;\n    margin: 0 8px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
